import React, { useState } from 'react';
import {
  Box, Typography, Button, CircularProgress, Paper, Tooltip
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import ImageSearchIcon from '@mui/icons-material/ImageSearch';
import BackgroundImageSelectionDialog from '../image_components/background_image_selection_dialog';

export default function PromotionalBannerSettings({
  restaurantId,
  currentBannerUrl,
  onUpdateBanner, // function(imageId, imageUrl) handles API save and state update directly
}) {
  const [openGallery, setOpenGallery] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);

  const handleOpenGallery = () => {
    setOpenGallery(true);
  };

  const handleCloseGallery = () => {
    setOpenGallery(false);
  };

  const handleSelectImage = async (img) => {
    handleCloseGallery();
    setIsUpdating(true);
    await onUpdateBanner(img.image_id || img.id, img.image_url);
    setIsUpdating(false);
  };

  const handleDeleteBanner = async () => {
    setIsUpdating(true);
    await onUpdateBanner(null, null);
    setIsUpdating(false);
  };

  return (
    <Paper
      elevation={0}
      sx={{
        border: '1px solid #eaeaea',
        borderRadius: '16px',
        p: 3,
        mb: 4,
        ml: "20px",
        mr: "20px",
        backgroundColor: '#fafafa',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
      }}
    >
      <Box sx={{ width: '100%', mb: currentBannerUrl ? 2 : 1 }}>
        <Typography variant="h6" fontWeight={700} sx={{ color: '#333', textAlign: 'center' }}>
          ✨ Banner Promocional
        </Typography>
        <Typography variant="body2" sx={{ color: '#666', textAlign: 'center', mt: 0.5 }}>
          Aparecerá como una ventana emergente la primera vez que un cliente abre tu menú.
        </Typography>
      </Box>

      {isUpdating && (
        <Box sx={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,0.7)', zIndex: 10, borderRadius: '16px' }}>
          <CircularProgress size={30} />
        </Box>
      )}

      {currentBannerUrl ? (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, width: '100%', maxWidth: '300px' }}>
          <Box sx={{
            width: '100%',
            paddingTop: 'auto',
            position: 'relative',
            borderRadius: '12px',
            overflow: 'hidden',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
          }}>
            <img
              src={currentBannerUrl}
              alt="Promocional"
              style={{ width: '100%', height: 'auto', display: 'block', maxHeight: '400px', objectFit: 'contain', backgroundColor: '#fff' }}
            />
          </Box>
          <Box sx={{ display: 'flex', gap: 2, width: '100%' }}>
            <Button
              variant="outlined"
              color="primary"
              fullWidth
              startIcon={<ImageSearchIcon />}
              onClick={handleOpenGallery}
              sx={{ borderRadius: '10px', textTransform: 'none', fontWeight: 600 }}
            >
              Cambiar
            </Button>
            <Tooltip title="Quitar Banner">
              <Button
                variant="outlined"
                color="error"
                onClick={handleDeleteBanner}
                sx={{ borderRadius: '10px', minWidth: '48px', padding: 0 }}
              >
                <DeleteIcon />
              </Button>
            </Tooltip>
          </Box>
        </Box>
      ) : (
        <Button
          variant="contained"
          onClick={handleOpenGallery}
          startIcon={<AddPhotoAlternateIcon />}
          sx={{
            mt: 1,
            backgroundColor: '#C5A059',
            color: 'white',
            fontWeight: 600,
            py: 1.5,
            px: 4,
            borderRadius: '12px',
            textTransform: 'none',
            '&:hover': {
              backgroundColor: '#a3844a'
            }
          }}
        >
          Añadir Banner Promocional
        </Button>
      )}

      {/* Gallery Dialog Reutilizado */}
      <BackgroundImageSelectionDialog
        open={openGallery}
        handleClose={handleCloseGallery}
        restaurantId={restaurantId}
        onSelectImage={handleSelectImage}
      />
    </Paper>
  );
}
